import {gql} from "@apollo/client";

export const SELECT_DIPLOMAS = gql`
    {
        repository_diploma(where: {in_repo: {_eq: true}}, order_by: {title: asc}) {
            id
            title
            number
            defense_date                  
            filename
            catalog_number
            in_repo
            study {
              id
              name
              form
              level
              title
              polon_uuid
              polon_uid
              main_discipline
              course_instance_code
              course_id
            }
            diploma_authors {
              person {
                id
                first_name
                last_name
                polon_uid
              }
            }
            diploma_supervisors {
              employee {
                id
                first_name
                last_name
                polon_uuid
                degree_and_title {
                  name
                }
              }
            }
            diploma_reviewers {
              employee {
                id
                first_name
                last_name
                polon_uuid
                degree_and_title {
                  name
                }
              }
            }
        }
    }`

